import { __assign, __rest } from "tslib";
import { useState, useCallback } from 'react';
export function useReplyState() {
    var _a = useState({}), replyingComments = _a[0], setReplyingComments = _a[1];
    var onEditingStateChange = useCallback(function (commentId, state) { return function (replyState) {
        var _a;
        var _b = replyState, _c = commentId, value = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
        if (state === 'replying') {
            setReplyingComments(__assign(__assign({}, rest), (_a = {}, _a[commentId] = true, _a)));
        }
        else {
            setReplyingComments(rest);
        }
    }; }, []);
    var isReplyingToComment = useCallback(function (parentId) { return !!replyingComments[parentId]; }, [replyingComments]);
    return {
        onEditingStateChange: onEditingStateChange,
        isReplyingToComment: isReplyingToComment,
    };
}
//# sourceMappingURL=useReplyState.js.map